export enum FormDataMediaKeys {
  FILE = "file",
  CUSTOMER_ID = "customerId",
  TYPE = "type",
  NAME = "name",
  CAPTION = "caption",
  EXTENSION = "extension",
  LOGICAL_ADDRESS = "logicalAddress",
  EXTERNAL_ID = "externalId",
}
